import OCTContextBase from "./octContextBase";
import { octColorSettings, generatePalette, octThicknessGradient, zeissThicknessGradient, heidelbergThicknessGradient } from "../canvas/canvasUtils";
import { calculateThicknessMapAdjustment, getThicknessMapSize } from "./octUtils";
import { defaultSize } from "../canvas/geometry";

export default class VolumeContextBase extends OCTContextBase {
  constructor(group, exam, componentName, browserName, imgKey) {
    super(group, exam, componentName, browserName, imgKey);

    this.octColorSettings = octColorSettings();
    this.thicknessMapColorSettings = null;

    this.slicePalette = octThicknessGradient;
    this.isSpectralisVolume = browserName.toLowerCase().includes("spectralis") && (this.group.groupName.toLowerCase().includes("volume") || this.group.groupName.toLowerCase().includes("cube"));
    this.thicknessMapPalette = this.isSpectralisVolume ? heidelbergThicknessGradient : zeissThicknessGradient;

    this.showSegmentation = false;

    this.thicknessMapOpacity = 0.5;
    this.thicknessMapMinThicknessUm = 0;
    this.thicknessMapMaxThicknessUm = 500;
    this.thicknessMapThicknessStepUm = 100;

    this.relativeMapSize = defaultSize();
  }

  setOCTInfo(data) {
    super.setOCTInfo(data);

    if (this.thicknessMap) {
      let colorPalette = generatePalette(this.thicknessMapPalette);
      let linearAdjustment = calculateThicknessMapAdjustment(this.thicknessMapMinThicknessUm, 
        this.thicknessMapMaxThicknessUm, this.thicknessMap.depthSpacingMm);
      this.thicknessMapColorSettings = { colorPalette, linearAdjustment };
    }

    this.relativeMapSize = getThicknessMapSize(this);
  }

  toggleInverted() {
    this.octColorSettings.isInverted = !this.octColorSettings.isInverted;
    if (this.octColorSettings.isInverted) this.octColorSettings.colorPalette = null;
  }
  toggleColorPalette() {
    this.octColorSettings.isInverted = false;
    if (this.octColorSettings.colorPalette) this.octColorSettings.colorPalette = null;
    else this.octColorSettings.colorPalette = this.getSlicePalette();
  }

  toggleSegmentation() {
    this.showSegmentation = !this.showSegmentation;
  }

  updateThicknessMapOpacity(opacity) {
    this.thicknessMapOpacity = opacity;
  }

  getSlicePalette() {
    return generatePalette(this.slicePalette);
  }
}